import React, { useState } from 'react';
import { config } from '../config';
import { useToast } from '../contexts/ToastContext';

const UploadFilesMigracion = ({ expedienteId, currentPath, onUploadComplete }) => {
  const [uploading, setUploading] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const { showSuccess, showError } = useToast();

  const handleFileSelect = (e) => {
    const archivos = Array.from(e.target.files);
    setSelectedFiles(archivos);
  };

  const handleUpload = async () => {
    if (selectedFiles.length === 0) {
      showError('Por favor selecciona al menos un archivo');
      return;
    }

    try {
      setUploading(true);
      const formData = new FormData();
      selectedFiles.forEach((file) => {
        formData.append('archivos', file);
      });

      const response = await fetch(
        `${config.apiUrl}/folders/expediente/${expedienteId}/upload?folderPath=${encodeURIComponent(currentPath || '')}`,
        {
          method: 'POST',
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          },
          body: formData
        }
      );

      const result = await response.json().catch(() => ({}));

      if (!response.ok) {
        const msg = result?.error || result?.message || `Error ${response.status}`;
        throw new Error(msg);
      }

      showSuccess(`${result.uploadedFiles?.length || result.files?.length || selectedFiles.length} archivo(s) subido(s) correctamente`);

      setSelectedFiles([]);
      const input = document.getElementById('file-input-migracion');
      if (input) input.value = '';

      if (onUploadComplete) {
        onUploadComplete();
      }
    } catch (error) {
      console.error('Error subiendo archivos:', error);
      showError('Error al subir archivos: ' + (error.message || 'Intenta de nuevo.'));
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="upload-migracion-container" style={{
      backgroundColor: '#f8f9fa',
      border: '2px dashed #dee2e6',
      borderRadius: '8px',
      padding: '20px',
      marginBottom: '20px'
    }}>
      <div style={{ marginBottom: '15px' }}>
        <h5 style={{ margin: '0 0 8px 0', color: '#495057' }}>
          <i className="fas fa-upload"></i> Subir Archivos (Modo Migración)
        </h5>
        <p style={{ margin: 0, fontSize: '0.9em', color: '#6c757d' }}>
          Carpeta actual: <strong>{currentPath || 'Raíz del expediente'}</strong>
        </p>
      </div>

      <div style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
        <label htmlFor="file-input-migracion" className="btn btn-outline-primary" style={{
          cursor: 'pointer',
          margin: 0
        }}>
          <i className="fas fa-file-upload"></i> Seleccionar Archivos
        </label>
        
        <input
          id="file-input-migracion"
          type="file"
          multiple
          onChange={handleFileSelect}
          style={{ display: 'none' }}
        />

        {selectedFiles.length > 0 && (
          <>
            <span style={{ color: '#28a745', fontWeight: '500' }}>
              {selectedFiles.length} archivo(s) seleccionado(s)
            </span>
            
            <button
              className="btn btn-success"
              onClick={handleUpload}
              disabled={uploading}
              style={{ marginLeft: 'auto' }}
            >
              {uploading ? (
                <>
                  <i className="fas fa-spinner fa-spin"></i> Subiendo...
                </>
              ) : (
                <>
                  <i className="fas fa-cloud-upload-alt"></i> Subir Ahora
                </>
              )}
            </button>
          </>
        )}
      </div>

      {selectedFiles.length > 0 && (
        <div style={{ marginTop: '15px', maxHeight: '150px', overflowY: 'auto' }}>
          <p style={{ margin: '0 0 8px 0', fontSize: '0.85em', color: '#6c757d', fontWeight: '500' }}>
            Archivos seleccionados:
          </p>
          <ul style={{ margin: 0, padding: '0 0 0 20px', fontSize: '0.85em' }}>
            {selectedFiles.map((file, index) => (
              <li key={index} style={{ marginBottom: '4px' }}>
                {file.name} <span style={{ color: '#6c757d' }}>({(file.size / 1024).toFixed(1)} KB)</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default UploadFilesMigracion;

